import { createFileRoute } from "@tanstack/react-router";
import { Badge, EmptyState, PageHeader } from "@oms/ui";
import { PageShell } from "@/components/pages/page-shell";

export const Route = createFileRoute("/app/analytics")({
  component: AnalyticsPage,
});

function AnalyticsPage() {
  return (
    <PageShell>
      <PageHeader
        title="Analytics"
        description="Revenue, fulfillment speed, and channel performance."
        actions={<Badge variant="neutral">Coming soon</Badge>}
      />
      <EmptyState
        title="Coming soon"
        description="Analytics and reporting is under development. Revenue charts and channel performance insights will be available in a future update."
      />
    </PageShell>
  );
}
